import { AuthenticationAPI } from './authentication.js';
import { COUNTRY_UAE_ID, ROOT_URL } from './constants.js'
import fetcher from './fetcher.js';
import { searchParamsFromObject } from './utils.js';

class PortfolioAPI {
  static async getList({ country_id, offset = 0, limit = 10, sort_by = '' }) {
    const params = searchParamsFromObject({ country_id, offset, limit, sort_by }).toString();
    let url = ''
    url = `${ROOT_URL}/api/v1/portfolios/portfolios/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

  static async getItem(portfolioId) {
    const params = searchParamsFromObject({ identifier: portfolioId })
    const url = `${ROOT_URL}/api/v1/portfolios/portfolios/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data[0];
  }

  static async generateStaticParams(params) {
    const portfolioList = await PortfolioAPI.getList(params)
    return portfolioList.map((portfolio) => ({
      portfolioId: portfolio.id,
      portfolioUsername: portfolio.username,
    }))
  }

}

class PositionAPI {
  static async getList({ country_id = COUNTRY_UAE_ID, portfolio_identifier }) {
    const params = searchParamsFromObject({ country_id, portfolio_identifier }).toString();
    const url = `${ROOT_URL}/api/v1/portfolios/positions/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }
}

class TransactionAPI {
  static async getList({ portfolio_identifier, offset = 0, limit = '', country_id = COUNTRY_UAE_ID }) {
    const params = searchParamsFromObject({ portfolio_identifier, offset, limit, country_id }).toString();
    const url = `${ROOT_URL}/api/v1/portfolios/transactions/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }
}

class HistoricalPortfolioAPI {
  static async getList({ portfolio_identifier, country_id = COUNTRY_UAE_ID }) {
    const params = searchParamsFromObject({ portfolio_identifier, country_id }).toString();
    const url = `${ROOT_URL}/api/v1/portfolios/historical-portfolios/search/?${params}`
    const res = await fetcher(url);
    const data = await res.json();
    return data;
  }

}

class PortfolioEditorAPI {
  static async getList({search = '', offset = 0, limit = 20}) {
    const params = searchParamsFromObject({
      offset, limit, search
    }).toString();
    let url = `${ROOT_URL}/api/v1/portfolios/editor/portfolios/?${params}`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }
  
  static async getItem({id}) {
    let url = `${ROOT_URL}/api/v1/portfolios/editor/portfolios/${id}/`
    const res = await AuthenticationAPI.get(url);
    const data = await res.json();
    return data;
  }

  static async updateItem({id, payload}) {
    let url = `${ROOT_URL}/api/v1/portfolios/editor/portfolios/${id}/`
    const res = await AuthenticationAPI.patch(url, payload, null, 'form');
    const data = await res.json();
    return data;
  }

}

export { 
  PortfolioAPI, 
  PositionAPI, 
  TransactionAPI, 
  HistoricalPortfolioAPI,
  PortfolioEditorAPI,
}